import { useLayoutEffect, useMemo, useState } from "react";
export const calcNbVisibleItems = (dropdownItemsLength, dropdownVisibleItems) => {
    return dropdownItemsLength > 0 ? Math.min(dropdownVisibleItems, dropdownItemsLength) : undefined;
};
export const useCalculateVisibleItems = ({ dropdownVisibleItems, visible, dropdownItemsLength, extraHeight = 0, menuItemSize, }) => {
    const [autoCalcVisibleItems, setAutoCalcVisibleItems] = useState();
    const visibleItems = useMemo(() => {
        if (dropdownVisibleItems === "auto") {
            if (autoCalcVisibleItems === undefined) {
                return undefined;
            }
            if (dropdownItemsLength < autoCalcVisibleItems) {
                return calcNbVisibleItems(dropdownItemsLength, autoCalcVisibleItems);
            }
            return autoCalcVisibleItems;
        }
        return calcNbVisibleItems(dropdownItemsLength, dropdownVisibleItems);
    }, [dropdownItemsLength, dropdownVisibleItems, autoCalcVisibleItems]);
    useLayoutEffect(() => {
        if (!visible) {
            setAutoCalcVisibleItems(undefined);
        }
        else {
            // dropdown height should not exceed 40% of viewport height
            const maxDropdownHeight = window.innerHeight * 0.4;
            const availableHeightForMenuItems = maxDropdownHeight - extraHeight;
            const numItems = Math.floor(availableHeightForMenuItems / menuItemSize);
            setAutoCalcVisibleItems(numItems);
        }
    }, [visible, extraHeight]);
    return { visibleItems, autoCalcVisibleItems };
};
//# sourceMappingURL=useCalculateVisibleItems.js.map